import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            fromDate: null,
            toDate: null,
            filter: '',
            payments: [],
            allCustomCategories: [],
            selectedCustomCategories: [],
            showTotalPrice: CONFIG_COMPANY.SHOW_TOTAL_PRICE_REPORT,
            showPaymentColumn: CONFIG_COMPANY.SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT,
            totalPrice: 0,
            totalDebt: 0,
            totalCount: 0,
            isMainAdmin: false
        }
    },
    computed: {

        filteredPayments() {
            let _self = this;
            var customCategory = this.selectedCustomCategories.length > 0 ? this.selectedCustomCategories[0] : '';
            let cPayments = customCategory !== '' ? this.payments.filter(e => e.customCategory === customCategory) : this.payments;
            return cPayments.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                item.surname.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                item.username.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                _self.checkNull(item.trainingTypes).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                _self.formatDate(item.paidDate).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                _self.formatDate(item.expireDate).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                _self.checkNull(item.membershipPackageName).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                item.trainingNumber.toString().toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                (checkNull(item.companyPayment).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1) ||
                (checkNull(item.comment).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1);
                // item.isForCompany ? (checkNull(item.companyPayment).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1) : item.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1;
            })
        },
        membershipStats() {
            const grouped = {};

            this.filteredPayments.forEach(item => {
                const membershipName = this.checkNull(item.membershipPackageName).trim().length > 0
                    ? this.checkNull(item.membershipPackageName).trim()
                    : this.locale.t('label_no_data');
                const paidMoney = Number(item.paidMoney || 0);

                if (grouped[membershipName] == null) {
                    grouped[membershipName] = {
                        membershipName: membershipName,
                        count: 0,
                        revenue: 0
                    };
                }

                grouped[membershipName].count += 1;
                grouped[membershipName].revenue += paidMoney > 0 ? paidMoney : 0;
            });

            return Object.keys(grouped).map(k => grouped[k]);
        },
        membershipCountChartData() {
            return [...this.membershipStats]
                .sort((a, b) => b.count - a.count)
                .slice(0, 12);
        },
        membershipRevenueChartData() {
            return [...this.membershipStats]
                .sort((a, b) => b.revenue - a.revenue)
                .slice(0, 12);
        },
        maxMembershipCount() {
            if (!this.membershipCountChartData.length) return 0;
            return Math.max(...this.membershipCountChartData.map(i => Number(i.count) || 0));
        },
        maxMembershipRevenue() {
            if (!this.membershipRevenueChartData.length) return 0;
            return Math.max(...this.membershipRevenueChartData.map(i => Number(i.revenue) || 0));
        }
    },
    methods: {
        load: load,
        clickSearch: clickSearch,
        checkNull: checkNull,
        chartWidth: chartWidth,
        shortLabel: shortLabel,
        formatNumber: formatNumber,
        formatMoney: formatMoney,
        displaySaradnik: displaySaradnik,
        clickSelectCustomCategory: clickSelectCustomCategory,
        keymonitor: keymonitor,
        isSelected: isSelected,
        displayAdditionalKit: displayAdditionalKit,
        getChipClass: getChipClass,
        calculate: calculate,
        paymentUser: paymentUser,
        formatDate: formatDate,
        deletePayment: deletePayment,
        formatDateAndTime: formatDateAndTime,

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.isMainAdmin = session.isMainAdmin();
        this.role = session.getRole();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.load()
        this.allCustomCategories = session.getConfig().customCategories.split(";");
    },
    watch: {
        'filter': function (newVal) {
            this.calculate()
        },
        'selectedCustomCategories': function () {
            this.calculate()
        }
    }
}

function calculate() {
    this.totalPrice = 0;
    this.totalDebt = 0;
    this.totalCount = 0;
    var slotCount = new Set()
    this.filteredPayments.forEach(e => {
        if(e.paidMoney > 0){
            this.totalPrice += e.paidMoney;
        }else {
            this.totalDebt += (e.paidMoney * -1);
        }
    })
    this.totalCount = this.filteredPayments.length;
}

function clickSearch() {
    this.load()
}

function chartWidth(value, max) {
    const v = Number(value) || 0;
    const m = Number(max) || 0;
    if (m <= 0) return '0%';
    const ratio = (v / m) * 100;
    return `${Math.max(6, Math.min(100, ratio)).toFixed(2)}%`;
}

function shortLabel(value, maxLen = 26) {
    const txt = (value || '').toString().trim();
    if (txt.length <= maxLen) return txt;
    return `${txt.slice(0, maxLen - 1)}…`;
}

function formatNumber(value) {
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Number(value) || 0);
}

function formatMoney(value) {
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Number(value) || 0);
}

function load() {
    let _self = this
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: _self.$moment(_self.toDate).format('DD-MM-YYYY')
    }

    AdminApiService.getPaymentByDate(model)
        .then((response) => {
            _self.payments = response.data
            _self.calculate();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })


}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function formatDateAndTime(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function displaySaradnik(item) {
    if (item.isForCompany && (item.companyPayment != null && item.companyPayment !== '')) {
        return item.companyPayment;
    } else {
        return '/';
    }
}

function displayAdditionalKit(kit) {
    if (kit != null && kit.length > 0) {
        return kit;
    } else {
        return '/';
    }
}

function checkNull(data) {
    if (data == null) return '';
    return data;
}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = [];
    } else {
        this.selectedCustomCategories = [];
        this.selectedCustomCategories.push(item)
    }
}

function deletePayment(id) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_payment_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deletePayment(id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_success_delete_payment'), 'success')
                _self.load()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function paymentUser(payment) {
    this.$router.push('/user-profile?id=' +  payment.userId + '&name=' + payment.name + ' ' + payment.surname + '&type=payments')

}



// WEBPACK FOOTER //
// ./src/components/Payment/PaymentReport.js